import { useEffect, useRef } from 'react';
import posthog from 'posthog-js';

const posthogToken = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN;

/** Puts the current screen on every later PostHog event, and records a pageview when it changes. Skipped during gameplay. */
export function usePostHogScreen(screen: string) {
  const lastPageviewScreen = useRef<string | null>(null);

  useEffect(() => {
    if (!posthogToken) {
      return;
    }

    if (screen === 'gameplay') {
      posthog.unregister('screen');
      posthog.unregister('scenario_id');
      posthog.unregister('scene_id');
      lastPageviewScreen.current = screen;
      return;
    }

    posthog.register({ screen });

    if (lastPageviewScreen.current === screen) {
      return;
    }
    lastPageviewScreen.current = screen;
    posthog.capture('$pageview', { screen });
  }, [screen]);
}
